export default "__VITE_ASSET__CUWr$Ssc__"